module.exports = __webpack_public_path__ + "static/media/ReitzPlatter2.d02f7f3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Reitz/ReitzPlatter2.jpg
// module id = 5760
// module chunks = 0